<div mat-dialog-content>
    {{data}}
</div>
<div mat-dialog-actions>
    <button class="btn btn-primary" mat-button  mat-dialog-close="false" cdkFocusInitial>Annulla</button>
    <button class="btn btn-primary" mat-button mat-dialog-close="true">Ok</button>
</div>